import { FormattedMessage } from "react-intl";

import { Tag } from "antd";

interface CmtActiveFieldProps {
  isActive: boolean;
}

export const CmtActiveField = ({ isActive }: CmtActiveFieldProps) =>
  isActive ? (
    <Tag color="green">
      <FormattedMessage id="table.active" defaultMessage="Active" />
    </Tag>
  ) : (
    <Tag color="red">
      <FormattedMessage id="table.inactive" defaultMessage="Inactive" />
    </Tag>
  );
